<div class="form-container">
    <div class="form-box">
        <h3>Did you complete the {{meetingsOrder[MEETING_FORM]}} meeting?</h3>
        <div class="btn-layout">
            <button (click)="accept(false)" class="u-btn sop-btn">NO</button>
            <button (click)="accept(true)" class="u-btn sop-btn">YES</button>
        </div>
    </div>
</div>
<simple-alert [message]="alertMessage" [alert]="alertType" [(show)]="showAlert"></simple-alert>